/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step3_BodyInputs */

const es_cap_step3_body = /** @type {(inputs: Cap_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisas barco, salida y tarifa. Decides tú, sin compromiso ni penalización.`)
};

const gl_cap_step3_body = /** @type {(inputs: Cap_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisas barco, saída e tarifa. Decides ti, sen compromiso nin penalización.`)
};

const en_cap_step3_body = /** @type {(inputs: Cap_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review boat, trip, and fee. Your decision — no obligation or penalty.`)
};

/**
* | output |
* | --- |
* | "Review boat, trip, and fee. Your decision — no obligation or penalty." |
*
* @param {Cap_Step3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step3_body = /** @type {((inputs?: Cap_Step3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step3_body(inputs)
	if (locale === "en") return en_cap_step3_body(inputs)
	return es_cap_step3_body(inputs)
});